import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { FormatCurrency } from "../../home/currencyFormatter";
import CustomLoading from "../CustomLoader";
import {
  getInvestorDetails,
  favouriteInvestor,
  updateFavouriteInvestor,
  getUpComingSips,
  getInvestors,
  validateTINWithPan
} from "../../../store/actions";
import { YES, TRUE, FALSE, INVESTMENTS, REQ_BY } from "../../../store/types";
import InvestmentTab from "./investmentsTab";
import Investments from "./investments";
import PieDiagram from "../../home/dashboard/piechart";

import CustomLoader from "../../forms/Loader";
import Image from "../../Image";
class InvestorDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      noData: false,
      count: 3,
      active: INVESTMENTS,
    };
  }

  async componentDidMount() {
    let { params } = this.props.match;
    const happy = await this.props.getInvestors({
      ARN: this.props.token,
      customfund: "189",
      AllFavFlag: "A",
    });

    params = {
      ...params,
      Uid: this.props.userId,
      ReqBy: REQ_BY,
      customfund: "189",
    };
    const response = await this.props.getInvestorDetails(params);
    if (response) {
      this.setState({ isLoading: false });
    } else {
      this.setState({ isLoading: false, noData: true });
    }

    if (this.props.investorData) {
      const Params = {
        Pan: this.props.investorData.PAN,
        YearFlag: new Date().getFullYear(),
        ARNCode:this.props.token,
      };
      await this.props.getUpComingSips(Params);
    }
  }

  favourite = async () => {
    let { fav, PAN: InvPan, invname: Name } = this.props.investorData;
    const FavFlag = fav === TRUE ? FALSE : TRUE;
    const params = { InvPan, FavFlag, Name, AgentCode: this.props.token };
    const response = await this.props.favouriteInvestor(params);
    if (response) {
      this.props.updateFavouriteInvestor({ InvPan, FavFlag });
    } else if (!response) {
      this.setState({
        errorMessage: "Already this pan ID member is added as a Favorite",
      });
    }
  };

  changeActive = (active) => () => {
    this.setState({ active });
  };

  render() {
    const {
      investorData,
      communicationDetails = [],
      pieData,
      investments,
      upComingSipDetails,
    } = this.props;
    const detailsEmail = communicationDetails.find(
      (detail) => detail.PAN === investorData.PAN && !!detail.email
    );
    const detailsMobile = communicationDetails.find(
      (detail) => detail.PAN === investorData.PAN && !!detail.Mobile
    );

    const fatca = this.props.investors.find(
      (ele) =>
        !!investorData && !!investorData.PAN && ele.Pan === investorData.PAN
    );

    const { isLoading, noData } = this.state;
    return (
      <div className="container-margin" style={{ marginBottom: 160 }}>
        {!isLoading ? (
          <React.Fragment>
            {!noData ? (
              <React.Fragment>
                <div>
                  <Paper style={{ width: "100%" }}>
                    <div className="investment_details_main_top_div">
                      <div className="inv_detail_left_col">
                        <div>
                          <div className="investor-details-left-container">
                            <div>
                              <div>
                                <Image
                                  src={"/images/investor_profile.svg"}
                                  className="investor-detail-profile-icon"
                                  //style={{ height: 60 }}
                                  alt="investor_profile"
                                />
                              </div>
                            </div>
                            <div style={{ marginLeft: 20 }}>
                              <div className="investor-details-name">
                                {investorData.invname}
                              </div>
                              <div className="pan-kyc-div">
                                <div className="investor-details-pan">
                                  PAN : {investorData.PAN}
                                </div>
                              </div>
                              <div className="flex">
                                <div className="investor-details-vefication-div">
                                  <Image
                                    src={
                                      investorData.KYC === YES
                                        ? "/images/checkmark_investors.svg"
                                        : "/images/cross_investors.svg"
                                    }
                                    alt={
                                      investorData.KYC === YES
                                        ? "checkmark"
                                        : "cross"
                                    }
                                    style={{ height: 8, marginLeft: 5 }}
                                  />
                                  <span className="investor-details-vefication-names">
                                    KYC
                                  </span>
                                  <Image
                                    src={
                                      !!fatca && fatca.Fatca === true
                                        ? "/images/checkmark_investors.svg"
                                        : "/images/cross_investors.svg"
                                    }
                                    // src={ "/images/cross.svg"}
                                    style={{ height: 8, marginLeft: 10 }}
                                    alt="cross"
                                  />
                                  <span className="investor-details-vefication-names">
                                    FATCA
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="investors-details-mail-div ">
                            <Image
                              src={"/images/mail_investor-details.svg"}
                              style={{ height: 15, marginRight: 7 }}
                              alt="mail"
                            />
                            <div className="investors-details-email">
                              {!!detailsEmail && detailsEmail.email
                                ? detailsEmail.email
                                : ""}
                            </div>

                            <Image
                              src={"/images/call_investor-details.svg"}
                              style={{ height: 15, marginRight: 7 }}
                              alt="call"
                            />
                            <div className="investor-details-phone-no">
                              {!!detailsMobile && !!detailsMobile.Mobile
                                ? detailsMobile.Mobile
                                : ""}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="investors-details-fav-button-container">
                            <div
                              className={
                                investorData.fav === TRUE
                                  ? "investors-details-fav-button-div mouse-pointer button-highlight"
                                  : "investors-details-fav-button-div mouse-pointer"
                              }
                              onClick={this.favourite}
                            >
                              <Image
                                src={"/images/star_fav.svg"}
                                style={{ height: 15, marginRight: 10 }}
                                alt="star_fav"
                              />
                              <div className="small_device_fav_text">
                                Favourite
                              </div>
                            </div>
                          </div>

                          {!!this.state.errorMessage ? (
                            <div
                              style={{
                                color: "red",
                                fontFamily: "Rubik-Italic",
                                textAlign: "center",
                                fontSize: 12,
                              }}
                            >
                              {this.state.errorMessage}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="investors-details-right-container">
                        <div className="flex responsive-flex">
                          <div className="inv-right-div-split-one">
                            <div className="investors-details-total-investment-div ">
                              <div style={{ margin: "10px 10px" }}>
                                <div className="investors-details-total-investment-name">
                                  Cost Value
                                </div>
                                <div className="investors-details-total-investment-value">
                                  {/* <FormatCurrency */}₹
                                  {!!this.props.investorTotal &&
                                  !!this.props.investorTotal.CostValue
                                    ? this.props.investorTotal.CostValue
                                    : "--NA--"}
                                  {/* /> */}
                                </div>
                              </div>
                              <div>
                                <Image
                                  src={
                                    "/images/mail_graph_investor_details.svg"
                                  }
                                  style={{ height: 75 }}
                                  alt="profile_graph"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="inv-right-div-split-two">
                            <div className="investors-details-current-value">
                              <div className="investors-details-change-name">
                                AUM
                              </div>
                              <div className="investors-details-change-percent">
                                ₹{" "}
                                {!!this.props.investorTotal &&
                                !!this.props.investorTotal.CurrentValue
                                  ? this.props.investorTotal.CurrentValue
                                  : "--NA--"}
                              </div>
                            </div>
                            <div className="investors-details-appreciation-div">
                              <div className="investors-details-change-name">
                                Overall Appr
                              </div>
                              <div className="investors-details-change-percent">
                                {/* <FormatCurrency */}
                                {!!this.props.investorTotal &&
                                !!this.props.investorTotal.GainVal
                                  ? this.props.investorTotal.GainVal
                                  : "--NA--"}

                                {/* {this.props.investorTotal.GainVal} */}
                                {/* /> */}
                                <Image
                                  src={
                                    this.props.investorTotal &&
                                    this.props.investorTotal.Gain
                                      ? this.props.investorTotal.Gain === "N"
                                        ? "/images/down_investors.svg"
                                        : "/images/up_investor-details.svg"
                                      : null
                                  }
                                  style={{ height: 15, marginLeft: 5 }}
                                  // alt="rise"
                                />
                              </div>
                            </div>

                            <div className="investors-details-change-box">
                              <div className="investors-details-change-name">
                                Today's Appr
                              </div>
                              <div className="investors-details-change-percent">
                                <div className="investors-details-change-percent">
                                  {!!this.props.investorTotal &&
                                  !!this.props.investorTotal.todaygain
                                    ? this.props.investorTotal.todaygain
                                    : "--NA--"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="investors-details-buttons-div">
                          <button
                            className="investors-details-button-intial-investment"
                            onClick={async () =>{
                               
                              const res = await this.props.validateTINWithPan({
                                  PAN:investorData?.PAN,
                                  TINFormat: "Individuals",
                                });

                                if (res?.statusCode !== "200") {
                                  const msg =
                                    res?.responseModel?.find((r) => r?.resCode !== "200")?.resMessage ||
                                    res?.responseModel?.[0]?.resMessage ||
                                    res?.statusMessage ||
                                    "Something went wrong";
                                  const popUpMessage = msg!=="Something went wrong" ? `${msg}\n\nClick OK to open the FATCA update page.`:msg;
                                  const redirectURL = msg!=="Something went wrong" ?"https://mfs.kfintech.com/fatcaupdate":""
                                  if (window.confirm(popUpMessage)) {
                                    if(redirectURL) window.open(redirectURL, "_blank");
                                  }
                                  return;
                                }    

                              this.props.history.push({
                                pathname: "/new-transaction/transction-types",
                                state: {
                                  investorData: investorData,
                                },
                              })
                            }
                            }
                            style={{
                              display:
                                !!investorData &&
                                !!investorData.PAN &&
                                investorData.PAN.charAt(3).toUpperCase() === "P"
                                  ? "flex"
                                  : "none",
                              justifyContent: "center",
                            }}
                          >
                            Initiate Investment
                          </button>
                          <button
                            className="investors-details-button-send-reports-investment button-highlight"
                            onClick={() =>
                              this.props.history.push({
                                pathname: "/mailBackRequest/investor",
                                state: {
                                  investorData: investorData,
                                },
                              })
                            }
                          >
                            Send Reports
                          </button>
                        </div>
                      </div>
                    </div>
                  </Paper>
                  <InvestmentTab
                    active={this.state.active}
                    onChange={this.changeActive}
                  />
                  <Paper>
                    <div className="investor-investments-container">
                      {this.state.active === INVESTMENTS ? (
                        <div className="investments-top-space">
                          <Investments
                            count={this.state.count}
                            active={this.state.active}
                          />
                          {investments.length > 3 && (
                            <React.Fragment>
                              {this.state.count === 3 ? (
                                <div
                                  className="investors-investemnts-see-more mouse-pointer"
                                  onClick={() =>
                                    this.setState({
                                      count: investments.length,
                                    })
                                  }
                                >
                                  See more
                                  <Image
                                    src={"/images/down_arrow_orange_bg.svg"}
                                    alt="down arrow (represents to see more Investments)"
                                    style={{ height: 10, marginLeft: 5 }}
                                  />
                                </div>
                              ) : (
                                <div
                                  className="investors-investemnts-see-more mouse-pointer"
                                  onClick={() => this.setState({ count: 3 })}
                                >
                                  See Less
                                  <Image
                                    src={"/images/down_arrow_orange_bg.svg"}
                                    alt="down arrow (represents to see more Investments)"
                                    style={{ height: 10, marginLeft: 5 }}
                                  />
                                </div>
                              )}
                            </React.Fragment>
                          )}
                          {/* <div>Note:Regarding Absolute Returns </div> */}
                        </div>
                      ) : (
                        <div>
                          <Investments
                            count={this.state.count}
                            active={this.state.active}
                          />
                          {upComingSipDetails.length > 3 && (
                            <React.Fragment>
                              {this.state.count === 3 ? (
                                <div
                                  className="investors-investemnts-see-more mouse-pointer"
                                  onClick={() =>
                                    this.setState({
                                      count: upComingSipDetails.length,
                                    })
                                  }
                                >
                                  See more
                                  <Image
                                    src={"/images/down_arrow_orange_bg.svg"}
                                    alt="down arrow (represents to see more Investments)"
                                    style={{ height: 10, marginLeft: 5 }}
                                  />
                                </div>
                              ) : (
                                <div
                                  className="investors-investemnts-see-more mouse-pointer"
                                  onClick={() => this.setState({ count: 3 })}
                                >
                                  See Less
                                  <Image
                                    src={"/images/down_arrow_orange_bg.svg"}
                                    alt="down arrow (represents to see more Investments)"
                                    style={{ height: 10, marginLeft: 5 }}
                                  />
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      )}

                      {this.state.active === INVESTMENTS ? (
                        <div className="investor-details-fund-allocation-container">
                          <div className="investor-investments-fund-allocation-container">
                            <div className="investor-investments-fund-allocation-title">
                              FUND ALLOCATION
                            </div>

                            <PieDiagram
                              data={pieData}
                              removePieData={true}
                              width={250}
                              percentile={true}
                              height={200}
                              cx={120}
                              cy={80}
                              innerRadius={30}
                              outerRadius={75}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </Paper>
                </div>
              </React.Fragment>
            ) : (
              <div>No Investor PAN found. Please submit investor PAN.</div>
            )}
          </React.Fragment>
        ) : (
          <CustomLoader display={!!isLoading ? true : false} />
        )}
      </div>
    );
  }
}

export default connect(
  ({ authReducer, investor, loading }) => {
    const { userId, token, communicationDetails, investorData } = authReducer;
    const {
      fundAllocation,
      pieData,
      investments,
      investors,
      investorTotal,
      upComingSipDetails,
    } = investor;
    const { count } = loading;
    return {
      userId,
      investorData,
      fundAllocation,
      pieData,
      communicationDetails,
      token,
      investors,
      investorTotal,
      investments,
      upComingSipDetails,
      count,
    };
  },
  {
    getInvestorDetails,
    favouriteInvestor,
    updateFavouriteInvestor,
    getUpComingSips,
    getInvestors,
    validateTINWithPan
  }
)(InvestorDetails);
